import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";

const Unauthorized = () => {
  return (
    <Box p={8}>
      <Heading size="lg" mb={3}>
        Access denied
      </Heading>
      <Text color="gray.600">You do not have access to this product.</Text>
    </Box>
  );
};

export default Unauthorized;
